{
  "level": "q302",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:q302",
    "objects": "AREAS.E3:q302.e3",
    "mesh": "TREES.E3:q302.e3"
  },
  "spawn_point": {
    "position": [
      613.4040578819183,
      793.3906773946371,
      -276.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      613.4040578819183,
      893.3906773946371,
      -276.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -279.618896484375,
      -2598.9130859375,
      -300.0
    ],
    "bbox_max": [
      1250.0,
      1120.0,
      1493.904296875
    ],
    "vertex_count": 166,
    "vertices": [
      [
        650.0,
        -2378.125,
        1284.1875
      ],
      [
        650.0,
        -2598.9130859375,
        1493.904296875
      ],
      [
        650.0,
        -2378.125,
        1284.1875
      ],
      [
        -279.618896484375,
        -1127.742431640625,
        -300.0
      ],
      [
        780.0,
        970.0,
        80.0
      ],
      [
        780.0,
        1120.0,
        80.0
      ],
      [
        960.0,
        940.0,
        80.0
      ],
      [
        780.0,
        940.0,
        60.0
      ],
      [
        780.0,
        970.0,
        80.0
      ],
      [
        950.0,
        970.0,
        80.0
      ],
      [
        360.0,
        970.0,
        60.0
      ],
      [
        360.0,
        980.0,
        80.0
      ],
      [
        760.0,
        979.0,
        78.0
      ],
      [
        740.0,
        979.0,
        78.0
      ],
      [
        720.0,
        979.0,
        78.0
      ],
      [
        360.0,
        980.0,
        78.0
      ],
      [
        360.0,
        979.0,
        78.0
      ],
      [
        740.0,
        979.0,
        78.0
      ],
      [
        740.0,
        980.0,
        80.0
      ],
      [
        760.0,
        940.0,
        78.0
      ],
      [
        360.0,
        930.0,
        60.0
      ],
      [
        360.0,
        560.0,
        78.0
      ],
      [
        360.0,
        540.0,
        78.0
      ],
      [
        740.0,
        921.0000610351562,
        78.0
      ],
      [
        760.0,
        921.0000610351562,
        78.0
      ],
      [
        740.0,
        920.0,
        80.0
      ],
      [
        740.0,
        921.0000610351562,
        78.0
      ],
      [
        780.0,
        920.0,
        80.0
      ],
      [
        780.0,
        750.0,
        78.0
      ],
      [
        780.0,
        921.0,
        78.0
      ],
      [
        360.0,
        560.0,
        78.0
      ],
      [
        360.0,
        560.0,
        80.0
      ],
      [
        456.27862548828125,
        511.0,
        78.0
      ],
      [
        360.0,
        511.0,
        78.0
      ],
      [
        360.0,
        520.0,
        60.0
      ],
      [
        740.0,
        930.0,
        78.0
      ],
      [
        760.0,
        930.0,
        78.0
      ],
      [
        740.0,
        930.0,
        80.0
      ],
      [
        740.0,
        930.0,
        78.0
      ],
      [
        310.0,
        970.0,
        80.0
      ],
      [
        310.0,
        980.0,
        80.0
      ],
      [
        310.0,
        250.0,
        80.0
      ],
      [
        310.0,
        970.0,
        80.0
      ],
      [
        359.0,
        730.0,
        78.0
      ],
      [
        359.0,
        731.0,
        78.0
      ],
      [
        358.9999694824219,
        398.9999694824219,
        78.0
      ],
      [
        359.0,
        400.0,
        78.0
      ],
      [
        358.9999694824219,
        280.0,
        78.0
      ],
      [
        359.0,
        399.0,
        78.0
      ],
      [
        359.0,
        560.0,
        78.0
      ],
      [
        359.0,
        540.0,
        78.0
      ],
      [
        359.0,
        941.0,
        78.0
      ],
      [
        358.9999694824219,
        731.0,
        78.0
      ],
      [
        359.0,
        980.0,
        78.0
      ],
      [
        358.9999694824219,
        941.0,
        78.0
      ],
      [
        360.0,
        511.0,
        78.0
      ],
      [
        359.0,
        511.0,
        78.0
      ],
      [
        359.0,
        400.0,
        78.0
      ],
      [
        360.0,
        921.0,
        78.0
      ],
      [
        359.0,
        921.0,
        78.0
      ],
      [
        359.0,
        560.0,
        78.0
      ],
      [
        359.0,
        979.0,
        78.0
      ],
      [
        360.0,
        979.0,
        78.0
      ],
      [
        350.0,
        970.0,
        60.0
      ],
      [
        340.0,
        980.0,
        80.0
      ],
      [
        359.0,
        979.0,
        78.0
      ],
      [
        340.0,
        979.0,
        78.0
      ],
      [
        340.0,
        560.0,
        78.0
      ],
      [
        340.0,
        560.0,
        80.0
      ],
      [
        340.0,
        400.0,
        78.0
      ],
      [
        340.0,
        400.0,
        80.0
      ],
      [
        330.0,
        477.0,
        78.0
      ],
      [
        310.0,
        979.0,
        78.0
      ],
      [
        330.0,
        980.0,
        80.0
      ],
      [
        330.0,
        979.0,
        78.0
      ],
      [
        330.0,
        750.0,
        78.0
      ],
      [
        330.0,
        750.0,
        80.0
      ],
      [
        330.0,
        400.0,
        78.0
      ],
      [
        330.0,
        400.0,
        80.0
      ],
      [
        320.0,
        956.0,
        78.0
      ],
      [
        310.0,
        956.0,
        78.0
      ],
      [
        330.0,
        960.0,
        78.0
      ],
      [
        330.0,
        960.0,
        80.0
      ],
      [
        320.0,
        956.0,
        78.0
      ],
      [
        1038.0,
        957.0,
        580.0
      ],
      [
        1044.800048828125,
        957.0,
        750.0
      ],
      [
        1250.0,
        957.0,
        140.0
      ],
      [
        1240.0,
        957.0,
        160.0
      ],
      [
        1235.0,
        957.0,
        118.0
      ],
      [
        1215.0,
        957.0,
        118.0
      ],
      [
        1215.0,
        957.0,
        120.0
      ],
      [
        1215.0,
        957.0,
        118.0
      ],
      [
        1235.0,
        900.0,
        118.0
      ],
      [
        1235.0,
        920.0,
        118.0
      ],
      [
        1215.0,
        920.0,
        118.0
      ],
      [
        1215.0,
        900.0,
        118.0
      ],
      [
        1215.0,
        920.0,
        120.0
      ],
      [
        1215.0,
        900.0,
        120.0
      ],
      [
        1215.0,
        900.0,
        118.0
      ],
      [
        1215.0,
        920.0,
        118.0
      ],
      [
        1242.6142578125,
        920.0,
        154.77146911621094
      ],
      [
        1240.0,
        920.0,
        160.0
      ],
      [
        1042.949951171875,
        957.0,
        750.0
      ],
      [
        760.0,
        900.0,
        140.0
      ],
      [
        780.0,
        900.0,
        140.0
      ],
      [
        930.0,
        900.0,
        140.0
      ],
      [
        958.2842407226562,
        900.0,
        140.0
      ],
      [
        780.0,
        900.0,
        80.0
      ],
      [
        780.0,
        900.0,
        140.0
      ],
      [
        986.2361450195312,
        930.0,
        118.0
      ],
      [
        980.0,
        930.0,
        118.0
      ],
      [
        1000.0,
        900.0,
        118.0
      ],
      [
        1000.0,
        930.0,
        118.0
      ],
      [
        986.2120971679688,
        930.0,
        118.0
      ],
      [
        980.0,
        900.0,
        118.0
      ],
      [
        958.2843017578125,
        900.0,
        118.0
      ],
      [
        980.0,
        930.0,
        118.0
      ],
      [
        960.0,
        930.0,
        118.0
      ],
      [
        930.0,
        900.0,
        118.0
      ],
      [
        930.0,
        900.0,
        118.0
      ],
      [
        960.0,
        930.0,
        118.0
      ],
      [
        960.0,
        930.0,
        120.0
      ],
      [
        930.0,
        900.0,
        120.0
      ],
      [
        822.5736083984375,
        1006.109130859375,
        140.0
      ],
      [
        865.0,
        990.0,
        140.0
      ],
      [
        805.0,
        1045.0,
        140.0
      ],
      [
        822.5736083984375,
        1006.109130859375,
        140.0
      ],
      [
        1000.0,
        970.0,
        118.0
      ],
      [
        780.0,
        950.0,
        118.0
      ],
      [
        824.0,
        950.0,
        118.0
      ],
      [
        780.0,
        950.0,
        120.0
      ],
      [
        780.0,
        950.0,
        118.0
      ],
      [
        780.0,
        900.0,
        118.0
      ],
      [
        760.0,
        900.0,
        118.0
      ],
      [
        760.0,
        900.0,
        220.0
      ],
      [
        810.0,
        900.0,
        453.33331298828125
      ],
      [
        780.0,
        900.0,
        118.00000762939453
      ],
      [
        780.0,
        750.0,
        118.0
      ],
      [
        360.0,
        980.0,
        100.0
      ],
      [
        360.0,
        980.0,
        80.0
      ],
      [
        360.0,
        980.0,
        190.0
      ],
      [
        360.0,
        980.0,
        120.0
      ],
      [
        360.0,
        980.0,
        190.0
      ],
      [
        360.0,
        980.0,
        340.0
      ],
      [
        360.0,
        980.0,
        120.0
      ],
      [
        360.0,
        960.0,
        105.0
      ],
      [
        360.0,
        980.0,
        100.0
      ],
      [
        360.0,
        960.0,
        100.0
      ],
      [
        360.0,
        960.0,
        100.0
      ],
      [
        360.0,
        960.0,
        105.0
      ],
      [
        539.9170532226562,
        879.8848876953125,
        80.0
      ],
      [
        539.9170532226562,
        879.8848876953125,
        140.0
      ],
      [
        539.9170532226562,
        879.8848876953125,
        140.0
      ],
      [
        539.9170532226562,
        879.8848876953125,
        460.0
      ],
      [
        254.03262329101562,
        970.0,
        120.0
      ],
      [
        254.03262329101562,
        970.0,
        140.0
      ],
      [
        114.03263092041016,
        970.0,
        155.0
      ],
      [
        114.03263092041016,
        970.0,
        175.0
      ],
      [
        310.0,
        970.0,
        112.5
      ],
      [
        260.0,
        970.0,
        112.5
      ],
      [
        256.0217590332031,
        980.0,
        120.0
      ],
      [
        256.0217590332031,
        980.0,
        140.0
      ],
      [
        116.0217514038086,
        980.0,
        155.0
      ],
      [
        116.0217514038086,
        980.0,
        175.0
      ],
      [
        300.0,
        980.0,
        120.0
      ],
      [
        300.0,
        970.0,
        112.5
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -825.0,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        400.0,
        -2275.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        650.0,
        -2850.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1600.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        650.0,
        -2850.0,
        1100.0
      ],
      "bbox_max": [
        2400.0,
        -2050.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -900.0,
        -2598.9130859375,
        -300.0
      ],
      "bbox_max": [
        650.0,
        -747.3431396484375,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -900.0,
        -2500.0,
        -300.0
      ],
      "bbox_max": [
        0.0,
        -1127.742431640625,
        1352.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4163157343864441,
        0.8524560332298279,
        0.3162277638912201
      ],
      "plane_d": 939.8093872070312,
      "bbox_min": [
        -588.8224487304688,
        -1371.68505859375,
        -300.0
      ],
      "bbox_max": [
        -279.618896484375,
        -1127.742431640625,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        -551.24462890625,
        -2598.9130859375,
        -300.0
      ],
      "bbox_max": [
        650.0,
        -747.3431396484375,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        0.0,
        -2598.9130859375,
        1284.1875
      ],
      "bbox_max": [
        650.0,
        -2378.125,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14309725165367126,
        0.2930086553096771,
        0.9453407526016235
      ],
      "plane_d": 323.03399658203125,
      "bbox_min": [
        -551.24462890625,
        -1600.0,
        -300.0
      ],
      "bbox_max": [
        650.0,
        -747.3431396484375,
        252.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4163157343864441,
        0.8524560332298279,
        0.3162277638912201
      ],
      "plane_d": 939.8093872070312,
      "bbox_min": [
        -551.24462890625,
        -1371.68505859375,
        -300.0
      ],
      "bbox_max": [
        523.75537109375,
        -747.3431396484375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        -309.5,
        250.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        1240.0,
        810.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        1250.0,
        760.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        970.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1250.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1470.0,
        970.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29408586025238037,
        0.9557790756225586,
        0.0
      ],
      "plane_d": -473.4782409667969,
      "bbox_min": [
        1250.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1470.0,
        944.6153564453125,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27716064453125,
        0.9608235955238342,
        0.0
      ],
      "plane_d": -491.8677978515625,
      "bbox_min": [
        1276.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        1290.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -910.0,
      "bbox_min": [
        1380.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1380.0,
      "bbox_min": [
        1380.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1380.0,
        910.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1250.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1340.0,
        944.6153564453125,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 360.0,
      "bbox_min": [
        300.0,
        250.0,
        60.0
      ],
      "bbox_max": [
        960.0,
        1140.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        360.0,
        510.0,
        60.0
      ],
      "bbox_max": [
        960.0,
        1140.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        360.0,
        940.0,
        60.0
      ],
      "bbox_max": [
        960.0,
        1140.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11043152958154678,
        0.0,
        0.9938837289810181
      ],
      "plane_d": 26.50357437133789,
      "bbox_min": [
        780.0,
        940.0,
        60.0
      ],
      "bbox_max": [
        960.0,
        1120.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        780.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        950.0,
        970.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        360.0,
        940.0,
        60.0
      ],
      "bbox_max": [
        760.0,
        1140.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        360.0,
        979.0,
        78.0
      ],
      "bbox_max": [
        760.0,
        1140.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        740.0,
        979.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        1130.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        360.0,
        940.0,
        78.0
      ],
      "bbox_max": [
        760.0,
        980.0,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        740.0,
        960.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        360.0,
        510.0,
        60.0
      ],
      "bbox_max": [
        960.0,
        940.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        360.0,
        510.0,
        60.0
      ],
      "bbox_max": [
        780.0,
        930.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        360.0,
        510.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        921.0000610351562,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        750.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        921.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        360.0,
        510.0,
        78.0
      ],
      "bbox_max": [
        550.0,
        560.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": -491.93499755859375,
      "bbox_min": [
        360.0,
        510.0,
        78.0
      ],
      "bbox_max": [
        456.27862548828125,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        360.0,
        511.0,
        60.0
      ],
      "bbox_max": [
        780.0,
        930.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": -491.93499755859375,
      "bbox_min": [
        360.0,
        511.0,
        60.0
      ],
      "bbox_max": [
        465.27862548828125,
        520.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11043152958154678,
        0.0,
        0.9938837289810181
      ],
      "plane_d": 26.50357437133789,
      "bbox_min": [
        740.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        960.0,
        940.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        740.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        960.0,
        940.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        740.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        780.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        740.0,
        920.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        740.0,
        930.0,
        78.0
      ],
      "bbox_max": [
        760.0,
        940.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        740.0,
        930.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        940.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        300.0,
        250.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 286.2166748046875,
      "bbox_min": [
        310.0,
        255.06324768066406,
        60.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        350.0,
        280.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        80.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        359.0,
        400.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        400.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        359.0,
        560.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        359.0,
        560.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        560.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        359.0,
        979.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        350.0,
        511.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        979.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        310.0,
        280.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        80.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        310.0,
        280.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        340.0,
        400.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        340.0,
        400.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        560.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        340.0,
        400.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        400.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -330.0,
      "bbox_min": [
        310.0,
        400.0,
        78.0
      ],
      "bbox_max": [
        340.0,
        980.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        310.0,
        400.0,
        78.0
      ],
      "bbox_max": [
        330.0,
        400.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 357.7709045410156,
      "bbox_min": [
        310.0,
        956.0,
        78.0
      ],
      "bbox_max": [
        330.0,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        320.0,
        956.0,
        78.0
      ],
      "bbox_max": [
        330.0,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -319.9999694824219,
      "bbox_min": [
        320.0,
        956.0,
        78.0
      ],
      "bbox_max": [
        320.0,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -750.0,
      "bbox_min": [
        330.0,
        400.0,
        78.0
      ],
      "bbox_max": [
        340.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        330.0,
        400.0,
        78.0
      ],
      "bbox_max": [
        340.0,
        560.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        330.0,
        400.0,
        78.0
      ],
      "bbox_max": [
        340.0,
        400.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        330.0,
        960.0,
        78.0
      ],
      "bbox_max": [
        340.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        330.0,
        960.0,
        78.0
      ],
      "bbox_max": [
        340.0,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        310.0,
        450.0,
        60.0
      ],
      "bbox_max": [
        359.0,
        979.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": -359.55975341796875,
      "bbox_min": [
        310.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        320.0,
        960.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -319.9999694824219,
      "bbox_min": [
        320.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        320.0,
        960.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547001957893372,
        -0.8320502638816833
      ],
      "plane_d": -201.35617065429688,
      "bbox_min": [
        320.0,
        450.0,
        60.0
      ],
      "bbox_max": [
        330.0,
        480.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -330.0,
      "bbox_min": [
        330.0,
        450.0,
        60.0
      ],
      "bbox_max": [
        330.0,
        480.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        300.0,
        380.0,
        78.0
      ],
      "bbox_max": [
        310.0,
        500.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        -309.5,
        250.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1240.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        1010.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        1130.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1020.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        1130.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 957.0,
      "bbox_min": [
        1038.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        1130.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        -0.44721361994743347
      ],
      "plane_d": 1180.6439208984375,
      "bbox_min": [
        1215.0,
        957.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1130.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1215.0,
        957.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1090.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        957.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1085.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1140.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        957.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1140.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        920.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1140.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1242.6142578125,
        920.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        1242.6142578125,
        920.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        -0.44721361994743347
      ],
      "plane_d": 1180.6439208984375,
      "bbox_min": [
        1240.0,
        916.4603881835938,
        154.77146911621094
      ],
      "bbox_max": [
        1242.6142578125,
        920.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        1140.0,
        910.0,
        98.0
      ],
      "bbox_max": [
        1140.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1215.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        957.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        -0.44721361994743347
      ],
      "plane_d": 1180.6439208984375,
      "bbox_min": [
        1215.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        957.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        957.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974521815776825
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        1010.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1044.800048828125,
        1100.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1010.0,
        960.0,
        130.0
      ],
      "bbox_max": [
        1030.0,
        1090.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.0,
        0.5547001957893372
      ],
      "plane_d": 768.2598266601562,
      "bbox_min": [
        1010.0,
        960.0,
        130.0
      ],
      "bbox_max": [
        1020.0,
        1090.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9993880391120911,
        0.0,
        0.034978583455085754
      ],
      "plane_d": 1016.0777587890625,
      "bbox_min": [
        1030.0,
        950.0,
        380.0
      ],
      "bbox_max": [
        1044.800048828125,
        1100.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 957.0,
      "bbox_min": [
        1037.0,
        957.0,
        580.0
      ],
      "bbox_max": [
        1044.800048828125,
        957.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.0,
      "bbox_min": [
        1037.0,
        957.0,
        580.0
      ],
      "bbox_max": [
        1042.949951171875,
        1093.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 957.0,
      "bbox_min": [
        1037.0,
        957.0,
        580.0
      ],
      "bbox_max": [
        1042.949951171875,
        957.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1215.0,
        867.8524780273438,
        118.0
      ],
      "bbox_max": [
        1235.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        887.8524780273438,
        118.0
      ],
      "bbox_max": [
        1215.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 957.0,
      "bbox_min": [
        1037.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        994.1422119140625,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.0,
      "bbox_min": [
        1037.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1061.0999755859375,
        994.1422119140625,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7077255845069885,
        0.7064874172210693,
        0.0
      ],
      "plane_d": 48.61865234375,
      "bbox_min": [
        1037.0,
        970.0,
        750.0
      ],
      "bbox_max": [
        1061.0999755859375,
        994.1422119140625,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        -309.5,
        250.0,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1240.0,
        600.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        760.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1008.2842407226562,
        1120.0,
        600.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        760.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1000.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        780.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1000.0,
        1045.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        930.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        1000.0,
        930.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 21.21319580078125,
      "bbox_min": [
        930.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        780.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1000.0,
        1045.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.3549693822860718,
        -0.9348779320716858,
        0.0
      ],
      "plane_d": 1232.57763671875,
      "bbox_min": [
        805.0,
        970.0,
        110.0
      ],
      "bbox_max": [
        1000.0,
        1045.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112828373908997,
        -0.4117811918258667,
        0.0
      ],
      "plane_d": 1163.89404296875,
      "bbox_min": [
        805.0,
        970.0,
        110.0
      ],
      "bbox_max": [
        1000.0,
        1045.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 330.9380798339844,
      "bbox_min": [
        960.0,
        970.0,
        110.0
      ],
      "bbox_max": [
        1000.0,
        990.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        980.0,
        970.0,
        118.0
      ],
      "bbox_max": [
        1000.0,
        980.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        780.0,
        930.0,
        108.0
      ],
      "bbox_max": [
        1000.0,
        970.0,
        120.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        780.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        970.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 21.21319580078125,
      "bbox_min": [
        960.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        950.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        980.0,
        950.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        970.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 107.99999237060547,
      "bbox_min": [
        820.0,
        930.0,
        108.0
      ],
      "bbox_max": [
        860.0,
        970.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 472.2575988769531,
      "bbox_min": [
        820.0,
        930.0,
        108.0
      ],
      "bbox_max": [
        840.0,
        970.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -949.9999389648438,
      "bbox_min": [
        820.0,
        950.0,
        108.0
      ],
      "bbox_max": [
        840.0,
        970.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        840.0,
        950.0,
        108.0
      ],
      "bbox_max": [
        840.0,
        970.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        760.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        780.0,
        950.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        760.0,
        950.0,
        118.0
      ],
      "bbox_max": [
        780.0,
        950.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        760.0,
        900.0,
        140.0
      ],
      "bbox_max": [
        1008.2842407226562,
        1099.6556396484375,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35496851801872253,
        -0.9348782300949097,
        -0.0
      ],
      "plane_d": 1212.5772705078125,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1099.6556396484375,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112825989723206,
        -0.4117816090583801,
        -0.0
      ],
      "plane_d": 1143.894287109375,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1099.6556396484375,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112825989723206,
        0.4117816090583801,
        0.0
      ],
      "plane_d": 283.2706604003906,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1099.6556396484375,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1045.0,
        170.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.3549693822860718,
        -0.9348779320716858,
        0.0
      ],
      "plane_d": 1232.57763671875,
      "bbox_min": [
        805.0,
        990.0,
        140.0
      ],
      "bbox_max": [
        865.0,
        1045.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112828373908997,
        -0.4117811918258667,
        0.0
      ],
      "plane_d": 1163.89404296875,
      "bbox_min": [
        805.0,
        1006.109130859375,
        140.0
      ],
      "bbox_max": [
        822.5736083984375,
        1045.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9778023958206177,
        0.0,
        0.2095290869474411
      ],
      "plane_d": 697.033447265625,
      "bbox_min": [
        760.0,
        900.0,
        220.0
      ],
      "bbox_max": [
        810.0,
        950.0,
        453.33331298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        760.0,
        701.7157592773438,
        80.0
      ],
      "bbox_max": [
        1000.0,
        900.0,
        570.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        760.0,
        730.0,
        80.0
      ],
      "bbox_max": [
        1000.0,
        900.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        750.0,
        118.0
      ],
      "bbox_max": [
        930.0,
        900.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 21.21319580078125,
      "bbox_min": [
        886.0660400390625,
        856.0660400390625,
        118.0
      ],
      "bbox_max": [
        930.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        750.0,
        80.0
      ],
      "bbox_max": [
        780.0,
        900.0,
        118.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9778023958206177,
        0.0,
        0.2095290869474411
      ],
      "plane_d": 697.033447265625,
      "bbox_min": [
        760.0,
        701.7157592773438,
        220.0
      ],
      "bbox_max": [
        835.0,
        900.0,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 360.0,
      "bbox_min": [
        -309.5,
        250.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1240.0,
        500.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        360.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1240.0,
        460.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        440.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        720.0,
        1240.0,
        290.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        490.0,
        980.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        1240.0,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        440.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        720.0,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        440.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        700.0,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        440.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        440.0,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        360.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        360.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        360.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        440.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071065902709961,
        0.7071070075035095,
        0.0
      ],
      "plane_d": -240.39385986328125,
      "bbox_min": [
        360.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        920.0,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1003.95166015625,
      "bbox_min": [
        360.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        920.0,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -510.0,
      "bbox_min": [
        360.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        550.0,
        869.8349609375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        7.597613875987008e-05,
        -1.0,
        0.0
      ],
      "plane_d": 749.9581909179688,
      "bbox_min": [
        410.0213928222656,
        749.9893188476562,
        240.0
      ],
      "bbox_max": [
        550.0,
        869.8349609375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0002752529107965529,
        -0.0
      ],
      "plane_d": -550.2064208984375,
      "bbox_min": [
        512.6419067382812,
        750.0,
        240.0
      ],
      "bbox_max": [
        550.0,
        869.8349609375,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7121667861938477,
        0.7020103335380554,
        -0.0
      ],
      "plane_d": -953.280517578125,
      "bbox_min": [
        512.6419067382812,
        799.9862060546875,
        360.0
      ],
      "bbox_max": [
        549.9862060546875,
        837.8707885742188,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -226.18081665039062,
      "bbox_min": [
        549.9669799804688,
        869.8349609375,
        80.0
      ],
      "bbox_max": [
        720.0,
        920.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        600.1320190429688,
        920.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        920.0,
        240.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071070075035095,
        -0.7071065902709961,
        -0.0
      ],
      "plane_d": 820.2514038085938,
      "bbox_min": [
        360.0,
        749.9893188476562,
        80.0
      ],
      "bbox_max": [
        539.9170532226562,
        920.0,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1003.95166015625,
      "bbox_min": [
        360.0,
        879.8848876953125,
        80.0
      ],
      "bbox_max": [
        539.9170532226562,
        920.0,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        360.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        499.80194091796875,
        920.0,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -309.5,
        250.0,
        80.0
      ],
      "bbox_max": [
        360.0,
        1115.0986328125,
        500.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        310.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        340.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        310.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        310.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        310.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        360.0,
        960.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        -309.5,
        830.0,
        100.0
      ],
      "bbox_max": [
        310.0,
        1115.0986328125,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -970.0,
      "bbox_min": [
        107.05952453613281,
        881.3681640625,
        100.0
      ],
      "bbox_max": [
        310.0,
        1000.0,
        420.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9807853102684021,
        -0.1950904279947281,
        0.0
      ],
      "plane_d": -59.91375732421875,
      "bbox_min": [
        107.05952453613281,
        881.3681640625,
        100.0
      ],
      "bbox_max": [
        310.0,
        970.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807853698730469,
        -0.195090189576149,
        0.0
      ],
      "plane_d": 77.39595031738281,
      "bbox_min": [
        107.05952453613281,
        934.9437866210938,
        155.0
      ],
      "bbox_max": [
        114.03263092041016,
        970.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        260.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        310.0,
        970.0,
        112.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        260.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        310.0,
        960.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        114.03263092041016,
        970.0,
        109.0
      ],
      "bbox_max": [
        310.0,
        1000.0,
        340.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9807853102684021,
        -0.1950904279947281,
        0.0
      ],
      "plane_d": -59.91375732421875,
      "bbox_min": [
        116.0217514038086,
        980.0,
        120.0
      ],
      "bbox_max": [
        260.0,
        1000.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807853698730469,
        -0.195090189576149,
        0.0
      ],
      "plane_d": 77.39595031738281,
      "bbox_min": [
        116.0217514038086,
        980.0,
        155.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        114.03263092041016,
        970.0,
        109.0
      ],
      "bbox_max": [
        310.0,
        980.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        114.03263092041016,
        970.0,
        112.5
      ],
      "bbox_max": [
        300.0,
        980.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807853698730469,
        -0.195090189576149,
        0.0
      ],
      "plane_d": 77.39595031738281,
      "bbox_min": [
        114.03263092041016,
        970.0,
        155.0
      ],
      "bbox_max": [
        116.0217514038086,
        980.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        300.0,
        970.0,
        112.5
      ],
      "bbox_max": [
        310.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 309.5,
      "bbox_min": [
        -309.5,
        971.800048828125,
        120.0
      ],
      "bbox_max": [
        -110.0,
        1115.0986328125,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        230.0
      ],
      "bbox_max": [
        -110.0,
        1115.0986328125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8544728755950928,
        -0.5194960832595825,
        0.0
      ],
      "plane_d": 700.9478759765625,
      "bbox_min": [
        -229.5,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1045.8167724609375,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        -150.0,
        1000.0,
        230.0
      ],
      "bbox_max": [
        -110.0,
        1040.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 110.0,
      "bbox_min": [
        -110.0,
        1000.0,
        230.0
      ],
      "bbox_max": [
        -110.0,
        1040.0,
        240.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}